// src/index.js
import jQuery from 'jquery'; // Import jQuery
window.$ = window.jQuery = jQuery; // Make jQuery globally accessible (optional)
//we comment all related datatable/file-input/tinymce/.. and import them in a separate files
// Importing CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'toastr/build/toastr.min.css';
import axios from 'axios';

// Importing JS libraries
import 'jquery';
// Import all of Bootstrap's JS
import * as bootstrap from 'bootstrap';
// or, specify which plugins you need:
// import { Tooltip, Toast, Popover } from 'bootstrap'
window.bootstrap = bootstrap;   //so we can use as ex. 'new bootstrap.Modal'
import 'ionicons';
import toastr from 'toastr';
window.toastr = toastr;
window.axios = axios;